import React from 'react';
import styled, { injectGlobal } from 'styled-components';
import LatoBold from '../assets/fonts/Lato-Bold.ttf';
import LatoRegular from '../assets/fonts/Lato-Regular.ttf';

injectGlobal`
  @font-face {
    font-family: Lato-Bold;
    src: url(${LatoBold}) format('truetype');
  }
  @font-face {
    font-family: Lato-Regular;
    src: url(${LatoRegular}) format('truetype');
  }
  * {
    box-sizing: border-box;
  }
  html, body, #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: Lato-Regular, sans-serif;
  }
`;

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  max-width: 100%;
  background: #fff;
`;

export default class GlobalWrapper extends React.Component<any, any> {
  render() {
    const { children, className } = this.props;
    return <Wrapper className={className}>{children}</Wrapper>;
  }
}
